import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=d63ebc74&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=ts"
export * from "./AdminPage.vue?vue&type=script&lang=ts"
import style0 from "./AdminPage.vue?vue&type=style&index=0&id=d63ebc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63ebc74",
  null
  
)

export default component.exports